export const STATUSES = ["New", "Contacted", "Discovery Call Booked", "Proposal Sent", "Follow Up", "Won", "Lost", "On Hold"];

export const statusColor = (s) => ({
  "New": "bg-[#38BDF8]/15 text-[#0b6f96] border-[#38BDF8]/40",
  "Contacted": "bg-amber-500/15 text-amber-700 border-amber-500/40",
  "Discovery Call Booked": "bg-violet-500/15 text-violet-700 border-violet-500/40",
  "Proposal Sent": "bg-indigo-500/15 text-indigo-700 border-indigo-500/40",
  "Follow Up": "bg-orange-500/15 text-orange-700 border-orange-500/40",
  "Won": "bg-emerald-500/15 text-emerald-700 border-emerald-500/40",
  "Lost": "bg-rose-500/15 text-rose-700 border-rose-500/40",
  "On Hold": "bg-stone-500/15 text-stone-600 border-stone-500/40",
}[s] || "bg-[#2E1B16]/10 text-[#2E1B16]/60 border-[#2E1B16]/20");
